import { SET_DMX_PROFILE_CHANNELS, SET_DMX_PROFILE_CHANNELS_SUCCESSFUL, SET_DMX_PROFILE_CHANNELS_FAILED } from './actionTypes';

export const setDmxProfileChannels = (profileChannels) => {
  return {
    type: SET_DMX_PROFILE_CHANNELS,
    payload: { profileChannels },
  };
};

export const setDmxProfileChannelsSuccessful = (message) => {
  return {
    type: SET_DMX_PROFILE_CHANNELS_SUCCESSFUL,
    payload: message,
  };
};

export const setDmxProfileChannelsFailed = (message) => {
  return {
    type: SET_DMX_PROFILE_CHANNELS_FAILED,
    payload: message,
  };
};
